import Dexie, { type EntityTable } from 'dexie';

interface Visit {
  id: number;
  idc1_staff: number;
  for: string;
  date: Date;
  start_time: Date;
  finish_time: Date;
  status: string;
  type: string;
  linkedclients: string;
}

interface Attendance {
  id: number;
  type: string;
  startLocation: GeolocationPosition;
  endLocation?: GeolocationPosition;
  notes?: string;
  aborted?: boolean;
  flagForNextVisit?: boolean;
  reasonForDiscrepancy?: string;
  postedSuccessfully?: number;
  staffMember: number;
}

interface CarePlan {
  id: number
  ida1_client: number
  preferred_name: string
  tasks: string
  ida4_client_care_plan: number
  date_of_birth: string
  key_box_code: string
  is_a_dnar_in_place: string
  is_dols_in_place: string
  list_of_allergies: string
  medical_history: string
  summary_of_need: string
  key_contacts: string
  deputies: string
  eating_and_drinking: string
  mobility_moving_and_handling: string
  personal_hygiene_support: string
  emotional_wellbeing: string
  skin_integrity: string
  communication: string
  sleep: string
  medication_pain_management: string
  behavioural_support: string
  reduction_of_falls_support: string
  continence_support: string
  epilepsy_support: string
  future_care_planning: string
  key_information: string
  date_version_released: string
  summary_of_changes: string
}

interface CarePlanTask {
  id: number
  value: any
  postedSuccessfully: number
}



const db = new Dexie('VisitDatabase') as Dexie & {
  visits: EntityTable<
    Visit,
    'id'
  >;
  attendances: EntityTable<Attendance, 'id'>
  carePlans: EntityTable<CarePlan, 'id'>
};


// Schema declaration:
db.version(27).stores({
  visits: "id, for, idc1_staff, date, start_time, finish_time, linkedclients",
  allocatedShifts: "id, for_day, idc1_staff, name",
  contractedShifts: "id, daysahead_0, idc1_staff, run_1",
  attendances:
    "id, staffMember, startLocation, endLocation, postedSuccessfully, readyToPost",
  carePlans: "id, summary_of_changes",
  tasks: "id",
  carePlanTasks: "id, value, postedSuccessfully",
  activities: "id, clientId, visitId, postedSuccessfully",
  issues: "id, clientId, visitId, postedSuccessfully",
  incidents: "id, clientId, visitId, postedSuccessfully",
  postingLog: "dateTime, datasetsPosted, errors",
  adhoc: "id, adhoc_type, postedSuccessfully, logged_by_0",
  expenses: "id, staffId, visitId, clientId, postedSuccessfully, cludgedSuccessfully",
  bodymaps: "id, clientId, postedSuccessfully",
  users: "id",
  holiday_list: "id, idc1_staff",
  holiday_status: "id, idc1_staff, holiday_year",
  holiday_requests: "id, name_01234567, postedSuccessfully",
  client_addresses: "id, first_name, last_name",
  chat_notifications: "roomId",
  clients: "ida1_client, idc1_staff"
});

export type { Visit, Attendance, CarePlan, CarePlanTask };
export { db };